import { ErrorEnum } from '../enums';
import { ErrorModel } from '../interfaces';

export const getErrorMessage = (errorCode: ErrorEnum, messageForClient: ErrorModel): ErrorModel => {
  return (
    errorMessages[errorCode] || {
      title: messageForClient?.title ?? 'Nieznany błąd',
      message: messageForClient?.message ?? 'Wystąpił nieznany błąd',
      isUnknown: !messageForClient?.title && !messageForClient?.message
    }
  );
};

const errorMessages: Record<ErrorEnum, ErrorModel> = {
  [ErrorEnum.HostApprovalAllSlotsAlreadyTaken]: {
    title: 'Lista graczy jest już pełna',
    message: 'Niestety, wszystkie miejsca w tej gierce są już zajęte',
    isUnknown: false
  },
  [ErrorEnum.GameAlreadyPending]: {
    title: 'Gra już się odbywa',
    message: 'Niestety, nie możesz dołączyć do gierki która się odbywa',
    isUnknown: false
  },
  [ErrorEnum.GameApplicationAlreadyPending]: {
    title: 'Dołączenie do gierki',
    message: 'Nie możesz dołączyć do gierki, w której już uczestniczysz',
    isUnknown: false
  },
  [ErrorEnum.GameApplicationAlreadyApproved]: {
    title: 'Dołączenie gracza do gierki',
    message: 'Nie możesz dołączyć gracza do gierki, w której już uczestniczy',
    isUnknown: false
  },
  [ErrorEnum.NotHandledTimezone]: {
    title: 'Błąd',
    message: 'Niewłaściwa strefa czasowa',
    isUnknown: false
  },
  [ErrorEnum.GameEndDateBeforeStartDate]: {
    title: 'Niewłaściwa data gry',
    message: 'Nie możesz ustawić daty zakończenia gry przed początkiem gry',
    isUnknown: false
  },
  [ErrorEnum.GameStartDateBeforeCurrentDatePlusOffset]: {
    title: 'Niewłaściwa data gry',
    message: 'Ustawiłeś niewłaściwą datę gry',
    isUnknown: false
  },
  [ErrorEnum.CannotEditGameAfterItsFinished]: {
    title: 'Edycja gry',
    message: 'Nie możesz edytować gry, która już się zakończyła',
    isUnknown: false
  },
  [ErrorEnum.CannotCancelGameIfSomePlayersAlreadyPaid]: {
    title: 'Usunięcie gry',
    message: 'Nie możesz usunąć gry kiedy ktoś już za nią zapłacił',
    isUnknown: false
  },
  [ErrorEnum.UserDeleted]: {
    title: 'Konto zostało usunięte',
    message: 'Konto zostało usunięte w przeszłości',
    isUnknown: false
  },
  [ErrorEnum.CannotApproveGamePlayerApplicationItsTooLate]: {
    title: 'Akceptacja gracza',
    message: 'Nie możesz zaakceptować gracza, jeśli gra się już rozpoczęła',
    isUnknown: false
  },
  [ErrorEnum.CannotCreateRatingAlreadyExists]: {
    title: 'Ocena aplikacji',
    message: 'Ocena zostala już wyslana. Nie możesz jej zmienic',
    isUnknown: false
  },
  [ErrorEnum.GameCancelled]: {
    title: 'Gra odwołana',
    message: 'Ta gierka została odwołana przez organizatora',
    isUnknown: false
  }
};
